import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import './News.css';
import { imageAPI, newsAPI, NewsItem } from '../services/api';
import { getImageUrl } from '../utils/imageUtils';

const News: React.FC = () => {
  const navigate = useNavigate();
  const [news, setNews] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // 获取新闻数据
  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await newsAPI.getNews({ 
          limit: 6, 
          status: '' // 暂时不限制状态，获取所有新闻
        });
        console.log('新闻API响应:', response);
        setNews(response.news || []);
      } catch (err) {
        console.error('获取新闻失败:', err);
        setError('获取新闻失败，请稍后重试');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // 格式化日期显示
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return {
      date: `${year}/${month}`,
      dayNumber: day
    };
  };

  // 如果正在加载，显示加载状态
  if (loading) {
    return (
      <section id="news" className="news section">
        <div className="container">
          <div className="news-header">
            <h2 className="section-title">新闻资讯</h2>
            <p className="section-subtitle">News Information</p>
          </div>
          <div className="news-loading">
            <Spin size="large" />
            <p>加载新闻中...</p>
          </div>
        </div>
      </section>
    );
  }

  // 如果有错误，显示错误信息
  if (error) {
    return (
      <section id="news" className="news section">
        <div className="container">
          <div className="news-header">
            <h2 className="section-title">新闻资讯</h2>
            <p className="section-subtitle">News Information</p>
          </div>
          <div className="news-error">
            <p>{error}</p>
          </div>
        </div>
      </section>
    );
  }

  console.log('新闻数据:', news);

  return (
    <section id="news" className="news section">
      <div className="container">
        <div className="news-header">
          <h2 className="section-title">新闻资讯</h2>
          <p className="section-subtitle">News Information</p>
        </div>
        <div className="news-grid">
          {news.length > 0 ? (
            news.map((item) => {
              const { date, dayNumber } = formatDate(item.publishDate);
              return (
                <div 
                  key={item._id} 
                  className="news-card"
                  onClick={() => navigate(`/news/${item._id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="news-day-number">{dayNumber}</div>
                  <div className="news-date">{date}</div>
                  <h3 className="news-title">
                    {item.title.length > 10 ? `${item.title.substring(0, 10)}...` : item.title}
                  </h3>
                  <div className="news-image">
                    {item.coverImage ? (
                      <img 
                        src={`http://admin.jieyudayaofang.com/api/images/${item.coverImage}/view?t=${Date.now()}`}
                        alt={item.title}
                        onError={(e) => {
                          console.log('图片加载失败:', e);
                          console.log('图片ID:', item.coverImage);
                          console.log('图片URL:', `http://admin.jieyudayaofang.com/api/images/${item.coverImage}/view`);
                        }}
                      />
                    ) : (
                      <div className="news-image-placeholder">
                        <span>暂无图片</span>
                      </div>
                    )}
                  </div>
                  <button className="news-arrow-btn">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
              );
            })
          ) : (
            <div className="news-empty">
              <p>暂无新闻数据</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default News; 